'use client';
import Typography from '@/components/shared/typography/typography.component';
import classes from './styles.module.scss';
import Image from 'next/image';
import { CSSProperties } from 'react';

const ButtonWithIcon = ({
    text,
    active,
    buttonClicked,
    img,
    imgActive,
    style,
}: {
    text: string;
    active: boolean;
    buttonClicked: () => void;
    img: any;
    imgActive: any;
    style?: CSSProperties;
}) => {
    const iconSource = active ? imgActive : img;
    return (
        <button
            onClick={() => buttonClicked()}
            className={`${classes.container} ${active ? classes.active : ''}`}
            style={{ ...style, cursor: 'pointer' }}
        >
            <Image width={16} height={16} src={iconSource} alt="" />
            <Typography
                variant="body2Medium"
                className={`${classes.container__text} ${
                    active ? classes.active : ''
                }`}
            >
                {text}
            </Typography>
        </button>
    );
};

export default ButtonWithIcon;
